import React from 'react';
import './TestPreview.css';

function TestPreview({ questions, answers, categoryName, onEdit, onPublish, isLoading }) {
  return (
    <div className="step-section stitch-create-step stitch-preview-step">
      <div className="step-header stitch-create-heading">
        <span className="stitch-step-kicker stitch-success-kicker">✓ آماده انتشار</span>
        <h2>آزمونت آماده است!</h2>
        <p>یک بار پاسخ‌ها را مرور کن، سپس لینک اختصاصی‌ات را برای دوستات بفرست.</p>
      </div>

      <div className="preview-card">
        <div className="preview-header">
          <h3>چقدر منو می‌شناسی؟</h3>
          <div className="preview-info">
            <span>{questions.length} سوال</span>
            <span>دسته: {categoryName}</span>
          </div>
        </div>

        <div className="preview-questions-list">
          <h4>سوالات و پاسخ‌های شما</h4>
          {questions.map((question, index) => {
            const answer = question.options?.find((option) => option.option_value === answers[question.id]);
            const answerText = answer?.emoji
              ? answer.option_text.replace(answer.emoji, '').trim()
              : answer?.option_text;
            return (
              <div key={question.id} className="preview-question-row">
                <span className="preview-number">{index + 1}</span>
                <div className="preview-content">
                  <span className="preview-question-text">{question.question_text}</span>
                  <span className="preview-answer">پاسخ: {answer?.emoji} {answerText}</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="preview-note">
          <p>بعد از انتشار، لینک اختصاصی آزمون را دریافت می‌کنی و می‌توانی فوراً برای دوستات بفرستی.</p>
        </div>
      </div>

      <div className="step-actions">
        <button className="btn-secondary" onClick={onEdit} type="button">
          <span className="material-symbols-outlined" aria-hidden="true">edit</span>
          ویرایش پاسخ‌ها
        </button>
        <button className="btn-publish" onClick={onPublish} disabled={isLoading} type="button">
          <span className="material-symbols-outlined" aria-hidden="true">check_circle</span>
          {isLoading ? 'در حال انتشار...' : 'انتشار آزمون'}
        </button>
      </div>
    </div>
  );
}

export default TestPreview;
